import { getHttpStatus, isNetworkError } from "@/utils/httpErrors";

type Translate = (key: string) => string;

export const isBrowserOffline = (): boolean =>
  typeof navigator !== "undefined" && navigator.onLine === false;

export const getSyncTriggerErrorMessage = (
  error: unknown,
  t: Translate,
): string => {
  if (isNetworkError(error)) {
    return t("pms.sync.networkError");
  }

  if (getHttpStatus(error) === 409) {
    return t("pms.sync.alreadyRunning");
  }

  return t("pms.sync.triggerError");
};
